module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/masters/customer-risk-analysis/customer-risk-analysis.component.css
// module id = ./src/app/masters/customer-risk-analysis/customer-risk-analysis.component.css
// module chunks = main